/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsProject extends models.AppSecopsProjectBase {
    getFixupPrototypeFunction() { return AppSecopsProject.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsProject>): AppSecopsProject {
        let obj = Object.assign(new AppSecopsProject(), model);
        AppSecopsProject.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsProject>): AppSecopsProject {
        if (!model) return null;
        return AppSecopsProject.newInstance(<AppSecopsProject> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsProject) {
        if (!obj) return;

        models.AppSecopsProject.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsProject): boolean {
        if (models.AppSecopsProjectBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsProject.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (typeof this.created_at === "string") {
            this.created_at = new Date(<string><any>this.created_at);
        }
        if (typeof this.updated_at === "string") {
            this.updated_at = new Date(<string><any>this.updated_at);
        }
    }

    /**
     * Unique ID of the project
     */
    project_id: string;

    /**
     * Project created time
     */
    created_at: Date;

    /**
     * Name of the user who created a project
     */
    created_by: string;

    /**
     * Project updated time
     */
    updated_at: Date;

    /**
     * Name of the user who recently updated
     */
    updated_by: string;

}
